import Router from './util/Router';

// Routes, hyphens should be switched to camelCase
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
    common,
    home
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

/* eslint-disable-next-line */
import '../sass/main.scss';
